import type { SmallGalleryBlock } from "../types";

export const SMALL_GALLERIES: SmallGalleryBlock[] = [
  {
    key: "accounting-system-selection-and-setup",
    label: "Financial Services That Complement Your Accounting System Setup",
    description: [
      "Choosing the right accounting system is just the beginning. At Orsak Langner & Barthel PLLC, we offer a suite of services that support your financial operations before, during, and after setup. Whether you need help maintaining the books, forecasting growth, or ensuring compliance, we’re here to guide you every step of the way.",
      "Explore these related offerings:",
    ],
  },
  {
    key: "compilation-of-financial-statements",
    label:
      "Compilation of Financial Statements for Private Businesses and Individuals",
    description: [
      "Orsak CPA’s provides reliable compilation of financial statements that give Texas businesses, nonprofits, and individuals a clear snapshot of financial health. Our team ensures that your reports are accurate, professional, and aligned with industry standards, supporting informed decision-making and growth planning.",
      "Explore these related services:",
    ],
  },
  {
    key: "financial-position-job-descriptions",
    label:
      "Financial Position Job Descriptions and Role Clarity for Businesses and Nonprofits",
    description: [
      "Clear financial job descriptions help organizations in Houston and across Texas strengthen accountability and performance. Orsak Langner & Barthel PLLC assists businesses and nonprofits in defining financial roles, responsibilities, and reporting structures so that your team functions efficiently and supports compliance.",
      "Discover related services that enhance organizational clarity:",
    ],
  },
  {
    key: "individual-accounting",
    label:
      "Individual Accounting Services for High-Income Professionals and Families",
    description: [
      "High-income professionals and families in Texas rely on Orsak CPA’s for tailored individual accounting services. From managing personal finances to ensuring accurate tax reporting, we help clients protect their wealth and simplify complex financial matters with accuracy and discretion.",
      "See related individual accounting solutions:",
    ],
  },
  {
    key: "policies-and-procedures",
    label:
      "Financial Policies & Procedures Development for Businesses and Nonprofits",
    description: [
      "Strong financial policies and procedures form the backbone of compliance and internal control. Orsak Langner & Barthel PLLC works with Texas businesses and nonprofits to design customized financial procedures that promote consistency, efficiency, and accountability.",
      "Explore these related governance and compliance services:",
    ],
  },
  {
    key: "preparation-of-financial-statements",
    label:
      "Preparation of Financial Statements for Businesses, Nonprofits, and Individuals",
    description: [
      "Accurate financial statements are critical for lenders, investors, and regulators. Orsak CPA’s prepares financial statements that meet GAAP standards and provide valuable insights for decision-making. We support businesses, nonprofits, and individuals across Houston, Texas with clear, reliable reporting.",
      "Review related financial preparation services:",
    ],
  },
  {
    key: "software-selection-and-implementation",
    label:
      "Accounting Software Selection & Implementation for Growing Businesses",
    description: [
      "Choosing and implementing the right accounting software saves time and reduces costly errors. Orsak Langner & Barthel PLLC guides Texas businesses through software evaluation, selection, and rollout, ensuring your system integrates smoothly with existing operations and supports long-term growth.",
      "Explore related technology and implementation services:",
    ],
  },
  {
    key: "quickbooks-services",
    label: "QuickBooks Setup, Training & Support for Houston Businesses",
    description: [
      "QuickBooks works best when it's set up right. Orsak Langner & Barthel PLLC helps Texas businesses configure QuickBooks Online or Desktop, clean up existing files, and train staff so your books stay accurate and reliable.",
      "Explore related accounting and implementation services:",
    ],
  },
  {
    key: "budgeting-and-forecasts",
    label:
      "Budgeting & Financial Forecasting Services for Businesses and Organizations",
    description: [
      "Forward-looking budgets and forecasts help organizations prepare for growth and market shifts. Orsak CPA’s provides comprehensive budgeting and forecasting services for businesses and nonprofits across Texas, equipping leaders with actionable insights to guide strategy and improve financial performance.",
      "See related financial planning services:",
    ],
  },
  {
    key: "cash-flow-management",
    label:
      "Cash Flow Management Services for Businesses, Nonprofits, and Individuals",
    description: [
      "Managing cash flow is essential for stability and growth. Orsak Langner & Barthel PLLC helps Texas companies, nonprofits, and individuals develop strategies to balance inflows and outflows, improve liquidity, and plan for future financial needs with confidence.",
      "Explore these related cash flow solutions:",
    ],
  },
  {
    key: "disclosures-and-budget-support",
    label: "Disclosures & Budget Support for Financial Reporting and Grants",
    description: [
      "Orsak CPA’s assists businesses and nonprofits in preparing accurate disclosures and budget support for financial statements, grant applications, and compliance reporting. Our expertise helps Texas organizations present transparent, trustworthy financial information to stakeholders and regulators.",
      "Discover related reporting and compliance services:",
    ],
  },
  {
    key: "gaap-implementation",
    label: "GAAP Implementation Services for Businesses and Nonprofits",
    description: [
      "Ensuring compliance with Generally Accepted Accounting Principles (GAAP) is vital for accurate reporting and investor confidence. Orsak Langner & Barthel PLLC guides Texas businesses and nonprofits through GAAP implementation, from policy alignment to reporting adjustments, ensuring your financial records meet professional standards.",
      "Explore related compliance and assurance services:",
    ],
  },
  {
    key: "medicare-cost-reports",
    label:
      "Medicare Cost Report Preparation for Hospices and Healthcare Providers",
    description: [
      "Healthcare providers in Texas trust Orsak CPA’s for precise Medicare cost report preparation. Our team helps hospices, hospitals, and clinics remain compliant while maximizing reimbursements. With deep knowledge of healthcare regulations, we streamline reporting so providers can focus on patient care.",
      "See related healthcare financial services:",
    ],
  },
  {
    key: "supplemental-schedules",
    label:
      "Supplemental Schedules for Accurate Financial Reporting and Audit Readiness",
    description: [
      "Supplemental schedules add transparency and detail to financial statements. Orsak Langner & Barthel PLLC prepares customized schedules that enhance audit readiness, meet lender requirements, and provide stakeholders with confidence in your reporting. Serving businesses and nonprofits across Texas.",
      "Discover related audit and reporting services:",
    ],
  },
  {
    key: "succession-planning-and-wealth-transfer",
    label:
      "Succession Planning & Wealth Transfer for High-Net-Worth Individuals and Families",
    description: [
      "Preserving wealth and ensuring a smooth transfer to the next generation requires careful planning. Orsak CPAs provides succession and wealth transfer strategies tailored to high-net-worth families in Houston and across Texas, addressing tax efficiency, estate planning, and legacy preservation.",
      "Explore related estate and personal planning services:",
    ],
  },
  {
    key: "audit-of-financial-statements",
    label: "Related Financial Services That Complement Your Audit",
    description: [
      "At Orsak Langner & Barthel PLLC, we offer a full range of assurance and financial support services tailored to Texas businesses, nonprofits, and individuals. Whether you're preparing for an audit, streamlining your internal controls, or seeking broader financial guidance, our team can help ensure every aspect of your financial foundation is strong.",
      "Explore these related services to enhance or support your audit engagement:",
    ],
  },
  {
    key: "audits-reviews-and-financial-statements",
    label: "Complementary Services for Better Financial Oversight",
    description: [
      "Your audit or financial review is only one part of your financial foundation. Orsak CPA’s provides several related services that help ensure accuracy, compliance, and planning readiness.",
      "Explore additional support:",
    ],
  },
  {
    key: "internal-control-documentation",
    label:
      "Internal Control Documentation Services for Businesses and Nonprofits",
    description: [
      "Strong internal controls protect assets, reduce risk, and ensure compliance. Orsak Langner & Barthel PLLC documents and strengthens internal control systems for businesses and nonprofits across Texas, helping organizations safeguard operations and build stakeholder trust.",
      "Explore related control and compliance services:",
    ],
  },
  {
    key: "internal-controls",
    label: "Internal Controls for Businesses and Nonprofits",
    description: [
      "Effective internal controls are the foundation of financial security. Orsak CPAs partners with Texas organizations to design, test, and monitor control systems that prevent fraud, enhance efficiency, and support long-term success.",
      "Discover related governance and compliance services:",
    ],
  },
  {
    key: "review-of-financial-statements",
    label:
      "CPA Review of Financial Statements for Private Companies and Nonprofits",
    description: [
      "When a full audit is not required, a CPA review provides assurance and credibility. Orsak Langner & Barthel PLLC performs financial statement reviews for private companies and nonprofits across Texas, offering stakeholders confidence in the accuracy of your financial information.",
      "Explore related assurance services:",
    ],
  },
  {
    key: "special-purpose-financial-statements",
    label:
      "Special Purpose Financial Statements for Planning, Projections, and Presentations",
    description: [
      "Special purpose financial statements help businesses and nonprofits present tailored financial information for lenders, investors, or internal planning. Orsak CPA’s prepares clear, accurate reports that meet unique needs while supporting decision-making and compliance across Texas.",
      "See related custom reporting services:",
    ],
  },
  {
    key: "part-time-controller-cfo",
    label: "Part-Time Controller & CFO Services for Growing Organizations",
    description: [
      "Not every business needs a full-time CFO, but every organization needs strategic financial leadership. Orsak Langner & Barthel PLLC provides part-time controller and CFO services for growing businesses and nonprofits across Texas, offering guidance on budgeting, reporting, and financial strategy without the overhead of a full-time hire.",
      "Explore related outsourced financial leadership services:",
    ],
  },
  {
    key: "debt-covenant-compliance",
    label:
      "Debt Covenant Compliance Services for Lenders, Borrowers, and Businesses",
    description: [
      "Meeting debt covenant requirements is essential for maintaining strong lender relationships. Orsak CPA’s helps Texas businesses and borrowers ensure compliance through accurate reporting, proactive monitoring, and strategic financial planning that reduces risk and supports long-term growth.",
      "Discover related financial compliance services:",
    ],
  },
  {
    key: "development-of-budgets",
    label: "Development of Budgets for Businesses, Nonprofits, and Individuals",
    description: [
      "A well-structured budget is the foundation of financial success. Orsak Langner & Barthel PLLC assists Texas businesses, nonprofits, and individuals in creating realistic budgets that align with goals, improve decision-making, and prepare for future financial needs.",
      "See related financial planning services:",
    ],
  },
  {
    key: "development-of-financial-policies-and-procedures",
    label:
      "Development of Financial Policies & Procedures for Businesses and Nonprofits",
    description: [
      "Clear financial policies and procedures ensure accountability, compliance, and operational efficiency. Orsak CPA’s works with Texas organizations to create tailored policies that align with industry standards, strengthen internal controls, and support long-term growth.",
      "Explore related governance and compliance services:",
    ],
  },
  {
    key: "successful-planning",
    label:
      "Strategic Financial Planning for Long-Term Business and Personal Success",
    description: [
      "Strong financial planning turns goals into actionable strategies. Orsak Langner & Barthel PLLC partners with Texas businesses and individuals to build long-term financial plans that balance growth, tax efficiency, and personal wealth management.",
      "Discover related strategic planning services:",
    ],
  },
  {
    key: "personal-financial-statements",
    label:
      "Personal Financial Statement Preparation for High-Net-Worth Individuals",
    description: [
      "Personal financial statements provide a complete view of assets, liabilities, and net worth. Orsak Langner & Barthel PLLC prepares detailed personal financial statements for high-net-worth clients across Texas, helping individuals secure financing, plan estates, and manage wealth with confidence.",
      "See related individual financial services:",
    ],
  },
  {
    key: "estate-and-trusts",
    label: "Estate & Trust Tax and Reporting Services",
    description: [
      "Estate and trust planning requires precision to minimize tax burdens and preserve wealth. Orsak CPA’s assists Texas families and individuals with estate and trust tax preparation, compliance, and reporting to ensure smooth transitions and long-term financial security.",
      "Discover related estate and wealth planning services:",
    ],
  },
  {
    key: "federal-tax-return-preparation",
    label:
      "Federal Tax Return Preparation Services for Individuals and Businesses",
    description: [
      "Filing accurate and timely federal tax returns is critical for avoiding penalties and maximizing savings. Orsak Langner & Barthel PLLC prepares federal tax returns for individuals, businesses, and estates across Texas, ensuring compliance with IRS requirements while identifying opportunities for deductions and credits.",
      "Explore related tax preparation services:",
    ],
  },
  {
    key: "state-franchise-income-and-tax-return",
    label: "State Franchise Income & Tax Return Preparation for Businesses",
    description: [
      "Texas businesses face complex state franchise and income tax requirements. Orsak CPA’s assists companies in preparing accurate state returns, ensuring compliance while minimizing liabilities. Our team helps organizations stay on top of changing regulations and avoid costly mistakes.",
      "See related state and local tax services:",
    ],
  },
  {
    key: "tax-compliance",
    label:
      "Tax Compliance Services for Individuals, Businesses, and Estates in Texas",
    description: [
      "Keeping up with tax compliance can be overwhelming for individuals, businesses, and estates. Orsak Langner & Barthel PLLC provides comprehensive compliance services across Texas, ensuring that filings are accurate, deadlines are met, and risks are minimized.",
      "Discover related compliance and reporting services:",
    ],
  },
  {
    key: "tax-planning",
    label:
      "Strategic Tax Planning for Businesses, Individuals, and High-Income Clients",
    description: [
      "Proactive tax planning helps clients reduce liabilities and keep more of what they earn. Orsak CPA’s partners with Texas businesses, families, and high-income individuals to develop customized strategies that optimize deductions, manage timing of income, and support long-term financial goals.",
      "Explore related tax strategy services:",
    ],
  },
  {
    key: "irs-resolution",
    label: "IRS Tax Resolution and Representation in Houston, Texas",
    description: [
      "When you owe back taxes or face IRS collection action, the right guidance makes all the difference. Orsak Langner & Barthel PLLC helps Texas taxpayers resolve liens, levies, garnishment, and unfiled returns while representing them before the IRS.",
      "Explore related tax services:",
    ],
  },
  {
    key: "oil-and-gas-royalty-tax",
    label: "Tax Services That Complement Oil & Gas Royalty Income",
    description: [
      "Mineral and royalty income rarely stands alone—it interacts with your estate plan, other investments, and multi-state filings. Orsak Langner & Barthel PLLC helps Texas owners coordinate depletion and interest-type strategy with the rest of their financial picture.",
      "Explore related services for owners and investors:",
    ],
  },
  {
    key: "ranch-and-landowner-tax",
    label: "Services That Support Texas Ranch, Farm, and Landowners",
    description: [
      "Land ownership touches agricultural valuation, mineral income, and long-term family transfer all at once. Our team helps ranchers, farmers, and landowners keep clean records and plan ahead so each season—and each generation—starts on solid footing.",
      "Explore related land and tax services:",
    ],
  },
  {
    key: "real-estate-investor-tax",
    label: "Tax and Advisory Services for Real Estate Investors",
    description: [
      "From your first rental to a growing syndication portfolio, real estate tax strategy compounds over time. Orsak CPAs helps Houston investors coordinate 1031 exchanges, depreciation, and entity structure with reliable books and reporting.",
      "Explore related investor services:",
    ],
  },
  {
    key: "business-sale-exit",
    label: "Services That Support a Successful Business Sale and Exit",
    description: [
      "A clean sale starts long before the offer. We help owners get their financials, tax position, and deal structure ready so diligence goes smoothly and more of the proceeds stay with you.",
      "Explore related planning services:",
    ],
  },
];

export const SMALL_GALLERIES_INDUSTRIES: SmallGalleryBlock[] = [
  {
    key: "construction",
    label: "CPA Services for the Construction Industry in Houston, Texas",
    description: [
      "From job-costing to WIP reporting, construction businesses need precise financials to keep projects profitable. Orsak Langner & Barthel PLLC supports contractors and builders across Houston, Texas with audits, budgeting, cash flow controls, and proactive tax planning tailored to the construction lifecycle.",
      "Explore these related services:",
    ],
  },
  {
    key: "manufacturing",
    label: "Manufacturing Accounting & Tax Services in Houston, Texas",
    description: [
      "Manufacturers face tight margins and complex inventory, depreciation, and compliance needs. Orsak Langner & Barthel PLLC helps Houston, Texas manufacturers strengthen GAAP alignment, improve cash flow, and optimize taxes—supporting growth from the shop floor to the boardroom.",
      "Explore these related services:",
    ],
  },
  {
    key: "real-estate",
    label: "Real Estate CPA Services for Investors & Developers in Houston",
    description: [
      "Real estate portfolios demand clear cash flow visibility, entity structuring, and long‑range tax strategy. Orsak Langner & Barthel PLLC serves Houston investors, developers, and property managers with forecasting, compliance, and wealth transfer planning aligned to your deal pipeline.",
      "Explore these related services:",
    ],
  },
  {
    key: "technology",
    label: "Startup & Technology CPA Services in Houston, Texas",
    description: [
      "High‑growth tech companies need scalable finance operations, clean statements, and forward‑looking planning. Orsak Langner & Barthel PLLC supports Houston startups and SaaS firms with budgeting, controller services, software implementation, and strategic tax planning.",
      "Explore these related services:",
    ],
  },
  {
    key: "transportation",
    label: "Transportation & Logistics Accounting in Houston, Texas",
    description: [
      "Freight and logistics companies run on thin timelines and tighter margins. Orsak Langner & Barthel PLLC helps Houston carriers, 3PLs, and fleets improve cash flow, plan budgets, and manage compliance—while optimizing taxes to keep operations moving.",
      "Explore these related services:",
    ],
  },
  {
    key: "oil-and-gas",
    label: "Oil & Gas CPA Services Across Houston and Texas",
    description: [
      "Energy operators and partners need robust reporting, JV accounting confidence, and disciplined tax strategy. Orsak Langner & Barthel PLLC supports upstream and midstream oil & gas with GAAP‑sound financials, succession and wealth transfer planning, and tax optimization.",
      "Explore these related services:",
    ],
  },
  {
    key: "healthcare",
    label: "Healthcare Accounting & Tax Services in Houston, Texas",
    description: [
      "Clinics and private practices require accurate reporting, payer compliance, and dependable cash flow. Orsak Langner & Barthel PLLC helps Houston physicians, dentists, and medical groups with Medicare‑related reporting, audits, and tax planning that supports sustainable growth.",
      "Explore these related services:",
    ],
  },
  {
    key: "ranching-and-agribusiness",
    label: "Ranching & Agribusiness CPA Services in Texas",
    description: [
      "Agricultural operations face seasonal cash cycles, asset planning, and complex tax considerations. Orsak Langner & Barthel PLLC partners with Texas farms and ranches to strengthen cash flow, plan estates and trusts, and create durable, tax‑efficient growth strategies.",
      "Explore these related services:",
    ],
  },
  {
    key: "professional",
    label: "CPA Services for Professional Firms in Houston, Texas",
    description: [
      "Law, architecture, consulting, and other professional firms need clean statements, predictable cash flow, and tax efficiency. Orsak Langner & Barthel PLLC equips Houston practices with controller support, budgeting, and planning built for advisory‑driven businesses.",
      "Explore these related services:",
    ],
  },
  {
    key: "nonprofits",
    label: "Nonprofit Accounting & Compliance Services in Houston, Texas",
    description: [
      "Mission‑driven organizations need grant‑ready reporting, donor transparency, and reliable compliance. Orsak Langner & Barthel PLLC supports Houston nonprofits with audits, budgeting, cash flow planning, and tax guidance aligned to stewardship and impact.",
      "Explore these related services:",
    ],
  },
];

export const SMALL_GALLERIES_BY_KEY = Object.fromEntries(
  [...SMALL_GALLERIES, ...SMALL_GALLERIES_INDUSTRIES].map(item => [
    item.key,
    item,
  ]),
);
